import React from "react";

import css from "./DecisionMakerContacts.module.scss";

type Props = {
  contacts: { jobTitle: string; seniority: string }[];
  buttonLink: string;
};

export function DecisionMakerContacts({ contacts, buttonLink }: Props) {
  return (
    <div className={css.decisionMakerContacts}>
      <h2 className={css.decisionMakerTitle}>Connect with key decision makers</h2>
      <p className={css.decisionMakerText}>
        Go beyond procurement contacts. Stotles gives you the decision makers that choose who gets
        the tender.
      </p>
      <a
        href={buttonLink}
        className={css.relatedContactsLink}
        onClick={() => window.open(buttonLink, "_blank")}
      >
        <div className={css.relatedContacts}>
          {contacts.map((contact) => (
            <div key={contact.jobTitle} className={css.relatedContact}>
              <div className={css.contactInfo}>
                <p className={css.contactName}>{contact.jobTitle}</p>
                <p className={css.contactSeniority}>{contact.seniority}</p>
              </div>
              <div className={css.contactDetails}>
                <p className={css.contactDetail}>
                  <span className={css.redacted}>Redacted</span>
                </p>
                <p className={css.contactDetail}>
                  <span className={css.redacted}>redacted</span>@
                  <span className={css.redacted}>redacted</span>.co.uk
                </p>
                <p className={css.contactDetail}>
                  +44 <span className={css.redacted}>01234 567 890</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </a>
    </div>
  );
}
